import React from "react";
import Section from "./Section";
import { useTranslation } from "react-i18next";
import SEO from "./SEO";
import PdfViewer from "./PdfViewer";

const Privacy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title={t("seo.pages.privacy.title")}
        description={t("seo.pages.privacy.description")}
        keywords={t("seo.pages.privacy.keywords")}
        canonical="https://deepsoulai.com/privacy"
      />
      <Section title={t("privacy.title")} maxW="1400px">
        <PdfViewer
          title={t("privacy.title")}
          zhUrl="https://appconfig.deepsoulai.com/privacy_tc_v1_6.pdf"
          zhCNUrl="https://appconfig.deepsoulai.com/privacy_sc_v1_6.pdf"
          enUrl="https://appconfig.deepsoulai.com/privacy_en_v1_6.pdf"
        />
      </Section>
    </>
  );
};

export default Privacy;
